import { ListTile, MessageStatus } from '@/components';
import { useLastMessageDisplay } from '@/features/chats/viewmodels';
import { formatChatDateTime, normalizeTimestamp } from '@/features/timeformatter';
import { UserProfile, Username } from '@/features/users';
import { useUserDetails } from '@/features/users/model';
import { ExternalBadge } from './ExternalBadge';
import PropTypes from 'prop-types';

const getUserId = user => user?.fromUserId || '';

export const RequestItem = ({ item, index, isPrevActive, isActive, onClick }) => {
   const userId = getUserId(item);
   const day = formatChatDateTime(new Date(normalizeTimestamp(item.messageTime)), 'message-card');
   const { lastMessageDisplay, isMyMessage } = useLastMessageDisplay(item);
   const { isExternal } = useUserDetails(userId, ['isExternal']);

   const dynamicClasses = ['request-item', isActive ? 'active' : '', index === 0 || isPrevActive ? 'no-border-top' : '']
      .filter(Boolean)
      .join(' ');

   return (
      <ListTile
         as="div"
         className={dynamicClasses}
         onClick={onClick}
         avatar={<UserProfile userId={userId} className="chat-avatar chat-avatar-fallback ct-flexCenter" />}
         title={
            <div className="ct-flex ct-aiCenter ct-gap6">
               <Username userId={userId} className="chat-name" />
               <ExternalBadge isExternalUser={isExternal} className="external-badge--compact" />
            </div>
         }
         subTitle={
            <>
               {isMyMessage && item?.deleteStatus !== 1 && <MessageStatus msgStatus={item?.msgStatus} />}
               {lastMessageDisplay.icon}
               <span className="chat-message-text">{lastMessageDisplay.label}</span>
            </>
         }
         trailing={<span className="chat-time">{day}</span>}
         dotStatus="read"
      />
   );
};

RequestItem.propTypes = {
   item: PropTypes.shape({
      userId: PropTypes.string,
      fromUserId: PropTypes.string,
      jid: PropTypes.string,
      userJid: PropTypes.string,
      messageTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      msgStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      deleteStatus: PropTypes.number,
   }).isRequired,
   index: PropTypes.number,
   isPrevActive: PropTypes.bool,
   isActive: PropTypes.bool,
   onClick: PropTypes.func,
};
